import { render, staticRenderFns } from "./extraOrderDetail.vue?vue&type=template&id=41295758&scoped=true&"
import script from "./extraOrderDetail.vue?vue&type=script&lang=js&"
export * from "./extraOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./extraOrderDetail.vue?vue&type=style&index=0&id=41295758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41295758",
  null
  
)

export default component.exports